import { Site } from "./sites";

const _languages = [
  "zh",
  "en",
  "de",
  "nl",
  "da",
  "es",
  "fi",
  "fr",
  "hr",
  "it",
  "no",
  "sv",
  "en",
  "en-us"
] as const;
export type Language = (typeof _languages)[number];
export const languages: Language[] = [..._languages];

export function isLanguage(lang?: string): boolean {
  return languages.indexOf(lang as Language) >= 0;
}

export type PathLanguage = Exclude<Language, "en-us">;

export const defaultLanguageLookup: Readonly<Record<Site, Language>> = {
  cn: "zh",
  com: "en",
  de: "de",
  nl: "nl",
  dk: "da",
  es: "es",
  fi: "fi",
  fr: "fr",
  hr: "hr",
  it: "it",
  no: "no",
  se: "sv",
  stage: "sv",
  uk: "en",
  us: "en-us"
};
